export default function RightArrowIcon() {
  // Triangle icons from https://svgbox.net/iconset/octicons
  // Whitespace removal from https://svgcrop.com/
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="8.5 5.68 6.82 12.62"
      className="static opacity-100"
    >
      <path d="M15.146 12.354l-5.792 5.792a.5.5 0 01-.854-.353V6.207a.5.5 0 01.854-.353l5.792 5.792a.5.5 0 010 .708z"></path>
    </svg>
  );
}
